import { EventApi } from '@fullcalendar/core';

export class AddAgendaEventsAction {
  static readonly type = '[AddAgendaEventsAction] add events';

  constructor(public payload: EventApi[]) {}
}

export class SetAgendaEventsAction {
  static readonly type = '[SetAgendaEventsAction] Set events';

  constructor(public payload: EventApi[]) {}
}

export class ReplaceAgendaEventAction {
  static readonly type = '[ReplaceAgendaEventAction] Replace event';

  constructor(public payload: { idToReplace: string; events: EventApi[] }) {}
}

export class ReplaceAgendaEventsAction {
  static readonly type = '[ReplaceAgendaEventsAction] Replace events';

  constructor(public payload: { idsToReplace: string[]; events: EventApi[] }) {}
}
